import generalStyles from "../styles.module.scss";
import styles from "./styles.module.scss";
import "photoswipe/dist/photoswipe.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import StatusBar from "../StatusBar";
import Step1 from "../Step1";
import Step2 from "../Step2";
import Step3 from "../Step3";
import StepNav from "../StepNav";
import {useAppData} from "../../context/Contexts";
import {getImageUrl} from "../../helpers/helpers";
import {useForm, useFormState} from "react-hook-form";
import {useStateWithCallbackLazy} from "use-state-with-callback";
import {useQuery} from "@tanstack/react-query";
import {queryClient} from "../ProductService";
import useMediaQuery from "../../hooks/useMediaQuery";
import fetchCheck from "../../services/CheckService";
import useCustomProductQuery from "../../services/CustomProductService";
import {Gallery, Item} from "react-photoswipe-gallery";
import BonusSection from "../BonusSection";
import Bonus3Section from "../Bonus3Section";
import Bonus3TitleSection from "../Bonus3Section/Bonus3TitleSection";
import RawHtml from "../RawHtml";
import Countdown from "../Countdown";
import MainStep from "../MainStep";
import StepNoCompatible from "../StepNoCompatible";
import useCaptionsQuery from "../../services/CaptionsService";

const Product: React.FC = (props) => {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [product, setProduct] = useState({});
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);
    const [slider1, setSlider1] = useState(null);
    const [slider2, setSlider2] = useState(null);
    const [reviewCount, setReviewCount] = useState(786);

    const [oldSlide, setOldSlide] = useState(0);
    const [activeSlide, setActiveSlide] = useState(0);
    const [activeSlide2, setActiveSlide2] = useState(0);


    const {
        captions_status,
        captions_data,
        captions_error,
        captions_isFetching,
        captions_refetch,
    } = useCaptionsQuery();

    useEffect(() => {
        setNav1(sliderRef1);
        setNav2(sliderRef2);
        captions_refetch();
    }, []);

    const {
        custom_status,
        custom_data,
        custom_error,
        custom_isFetching,
        custom_refetch,
    } = useCustomProductQuery();


    const {status, data, error, isFetching, refetch} = useQuery({
        queryKey: ["product"],
        queryFn: ({}) =>
            window.scs_force_custom === true ? custom_refetch() : fetchProduct(),
    });

    const [filterSortOrder, setFilterSortOrder] = useStateWithCallbackLazy([
        "title",
        "ascending",
    ]);

    const [queryAfter, setQueryAfter] = useState(null);

    const isMobile = useMediaQuery(768);
    const isTablet = useMediaQuery(1024);

    let Shopify = window.Shopify || {};
    Shopify.country = Shopify.country || "US";
    // console.log(`country: ${Shopify.country}`);

    useEffect(() => {
        if (currentAppData.show_upsell) {
            Shopify.analytics.publish("show_upsell", {campaign_id: 'double_offer'});
        }
    }, currentAppData.show_upsell);

    useEffect(() => {
        // if (currentAppData.show_offer) {
        //     Shopify.analytics.publish("show_offer", { campaign_id: 'double_offer'});
        // }
    }, currentAppData.show_offer);

    const defaultQuery = (opts) => {
        let q = `
      query @inContext(country: ${Shopify.country}) {

  product(id: "gid://shopify/Product/8207503130916") {
    id
    title
    handle
    availableForSale
    createdAt
    productType
    tags
    collections(first: 5) {
      edges {
        node {
          id
          title
        }
      }
    }
    images(first: 100) {
      edges {
        node {
          id
          url
          altText
        }
      }
    }
    media(first: 100) {
        edges {
            node {
                id
                mediaContentType
                alt
        
                previewImage {
                    src
                    url
                    id
                    width
                    height
                    altText
                }
            }
        }
    }
    extra_images: metafield(namespace: "custom", key: "extra_images") {
        namespace
        key
        value
        references(first: 100) {
            nodes {
              ... on MediaImage {
                mediaContentType
                image {
                  url
                  altText
                  id
                }
              }
            }
        }
    }   
    alternate_images: metafield(namespace: "custom", key: "alternate_images") {
        namespace
        key
        value
        references(first: 100) {
        nodes {
          ... on MediaImage {
            mediaContentType
            image {
              url
              altText
              id
            }
          }
        }
      }
    }
    options {
        id
        name
        optionValues {
            name
            id
        }
    }
    variants(first: 100) {
      edges {
        node {
          id
          sku
          availableForSale
          title
          currentlyNotInStock
          selectedOptions {
            name
            value
          }
          image {
            id
            url
          }
          priceV2 {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }

        }
      }
    }
  }
}`;

        return q;
    };

    const getSortKey = () => {
        switch (filterSortOrder[0]) {
            case "title":
                return "TITLE";
            case "price":
                return "PRICE";
            case "created_at":
                return "CREATED_AT";
            default:
                return "TITLE";
        }
    };

    const buildQuery = (opts) => {
        const sortKey = getSortKey();

        let q = defaultQuery({sortKey, ...opts});

        // console.log(opts)
        // console.debug(q)

        return q;
    };

    const fetchProduct = async (pageParam = null) => {
        //console.log(key);
        // console.log('pageParam: ');
        // console.log(pageParam);

        const myHeaders = new Headers();
        myHeaders.append(
            "X-Shopify-Storefront-Access-Token",
            "2ec833273cdc3f57cd90d9b80c9c5a80",
        );
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
            query: buildQuery({}),
            variables: {after: ""},
        });
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: graphql,
            redirect: "follow",
        };

        const response = await fetch(
            "https://seatcoversolutions-7977.myshopify.com/api/2025-07/graphql.json",
            requestOptions,
        ).catch((error) => console.log("error", error));

        const data = await response?.json();

        const prod = data.data.product;

        if (window.scs_use_alternate_images) {
            //console.log('BEFORE prod.images.edges', prod.images.edges);
            prod.images.edges = prod.images.edges.map((node) => {
                const altText = node.node.altText;
                //console.log('altText', altText);
                const alternate_image = prod.alternate_images.references.nodes.filter(
                    (v) => v.image.altText == altText,
                );
                if (alternate_image.length > 0) {
                    //console.log('found');
                    node.node.url = alternate_image[0].image.url;
                }
                return node;
            });
            //console.log('prod.images.edges', prod.images.edges);
        }
        if (window.scs_black_friday_2025 && prod.extra_images) {
            const extra_images = prod.extra_images.references.nodes.map(
                (v) => {
                    return {
                        'node': {
                            id: v.image.id,
                            altText: v.image.altText,
                            url: v.image.url,
                        }
                    };
                },
            ).filter((v) => {
                return (window.scs_promo_extra_images_filter &&
                    v.node.altText.includes(window.scs_promo_extra_images_filter));
            });
            if (extra_images.length > 0) {
                console.log('extra_images', extra_images);
                prod.images.edges = [...extra_images, ...prod.images.edges];
            }
        }

        if (window.scs_extra_media) {
            // const tmp = { node: {
            //         "id": "gid://scsbiz/VehicleMedia/4",
            //         "type": "video/mp4",
            //         "url": "https://www.seatcoversolutions.com/cdn/shop/t/25/assets/thumbnail-vid-scs.jpg",
            //         "video_url": "https://scsbiz.wearevisum.com/files/upload_624873738.mp4",
            //         "video_type": "video/mp4",
            //         "altText": "Special Luxury Seat Covers - Video - all"
            //     }
            // };
            prod.images.edges.splice(1, 0, window.scs_extra_media);
        }

        console.log("product 111: ", prod);

        setCurrentAppData((prevState) => {
            return {...prevState, product: prod, originalProduct: prod};
        });

        if (currentAppData?.year && currentAppData?.make && currentAppData?.model) {
            const check = await fetchCheck(
                currentAppData?.year,
                currentAppData?.make,
                currentAppData?.model,
                currentAppData?.trim,
                currentAppData?.color,
                currentAppData?.seat,
            );
            // console.log('check refetch result', check);
            if (check.compatibility === "N" && check.compatibility_custom === "N") {
                const newStep = 3;
                await setCurrentAppData((prevState) => {
                    return {...prevState, step: newStep};
                });
            }
            await setCurrentAppData((prevState) => {
                return {...prevState, check: check};
            });
            if (
                check.compatibility === "N" &&
                check.compatibility_custom !== "N" &&
                window.scs_force_normal !== true
            ) {
                const product = await getCustomProduct(
                    currentAppData?.model,
                    currentAppData?.trim,
                );
                // console.log('product fallback: ', product);
                //product.images = currentAppData.originalProduct.images;
                setCurrentAppData((prevState) => {
                    return {...prevState, product: product};
                });
            }
        }

        return data.data.product;
    };

    const {control, reset, register, handleSubmit, getValues, formState} =
        useForm({
            reValidateMode: "onBlur",
        });

    const thumbSettings = {
        centerMode: false,
        slidesToShow: 5,
        vertical: window.innerWidth >= 767,
        verticalSwiping: true,
        arrows: true,
        dots: false,
        swipeToSlide: true,
        focusOnSelect: true,
        className: "slider-nav-thumbnails",
        asNavFor: slider2 ? slider2 : null,
    };

    const sliderSettings = {
        dots: false,
        vertical: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: "slider-main",
        asNavFor: slider1 ? slider1 : null,
        beforeChange: (current, next) => {
            setOldSlide(current);
            setActiveSlide(next);
        },
        afterChange: (current) => setActiveSlide2(current),
    };

    useEffect(() => {
        console.log("AfterChange", activeSlide2);
        const targetElement = document.querySelector(
            `.slider-main [data-index="${activeSlide2}"] video`,
        );
        console.log("targetElement", targetElement);
        if (targetElement) {
            targetElement.play();
        }
    }, [activeSlide2]);

    useEffect(() => {
        console.log("oldSlide", oldSlide);
        console.log(slider1);
        const targetElement = document.querySelector(
            `.slider-main [data-index="${oldSlide}"] video`,
        );
        if (targetElement) {
            targetElement.pause();
        }
    }, [oldSlide]);

    //DONE: handle params from url (when present) - we need to preselect step1 and move to step2
    useEffect(() => {
        async function runCheck() {
            const queryParameters = new URLSearchParams(window.location.search);

            let year =
                window.sessionStorage.getItem("user_year") ?? currentAppData?.year;
            let make =
                window.sessionStorage.getItem("user_make") ?? currentAppData?.make;
            let model =
                window.sessionStorage.getItem("user_model") ?? currentAppData?.model;
            let trim =
                window.sessionStorage.getItem("user_trim") ?? currentAppData?.trim;
            let cab =
                window.sessionStorage.getItem("user_cab") ?? currentAppData?.cab;

            if (queryParameters.get("user_year")) {
                year = queryParameters.get("user_year") ?? currentAppData?.year;
                make = queryParameters.get("user_make") ?? currentAppData?.make;
                model = queryParameters.get("user_model") ?? currentAppData?.model;
                trim = queryParameters.get("trim") ?? undefined;
                cab = queryParameters.get("cab") ?? "";
            }

            if (queryParameters.get("year")) {
                year = queryParameters.get("year") ?? currentAppData?.year;
                make = queryParameters.get("make") ?? currentAppData?.make;
                model = queryParameters.get("model") ?? currentAppData?.model;
                trim = queryParameters.get("trim") ?? undefined;
                cab = queryParameters.get("cab") ?? "";
            }

            console.log('queryParameters:', year, make, model, trim);
            if (year && make && !model) {
                setCurrentAppData((prevState) => {
                    let newState = {
                        ...prevState,
                        year: year,
                        make: make,
                    };
                    return newState;
                });
            }

            if (year && make && model && year !== "" && make !== "" && model !== "") {
                let check = await fetchCheck(
                    year,
                    make,
                    model,
                    trim,
                    currentAppData.color,
                    currentAppData.seat,
                );

                // console.log("year, make, model, trim", year, make, model, trim);
                // console.log("check", check);

                // if it is custom compatibility - need to load the custom product
                if (
                    check.compatibility === "N" &&
                    check.compatibility_custom !== "N" &&
                    window.scs_force_normal !== true
                ) {
                    //const product = await getCustomProduct(model, trim);
                    // console.log('product fallback: ', year, make, model, check, trim);
                    //product.images = currentAppData.originalProduct.images;
                    // //TODO: check to see if we have trims and stay on step 1 if we do
                    // if (currentAppData?.has_trims || currentAppData?.has_cabs) {
                    //     newStep = 1;
                    // }

                    setCurrentAppData((prevState) => {
                        let newState = {
                            ...prevState,
                            // step: typeof trim == 'undefined' ? 1 : newStep,
                            year: year,
                            make: make,
                            model: model,
                            //product: product,
                            color: "Black",
                            check: check,
                        };
                        if (trim) {
                            newState["trim"] = trim;
                        }
                        if (cab) {
                            newState["cab"] = cab;
                        }
                        return newState;
                    });
                    return;
                }

                if (check.compatibility == "N" && check.compatibility_custom !== "N") {
                    window.scs_force_custom = true;
                    check = await fetchCheck(
                        year,
                        make,
                        model,
                        trim,
                        currentAppData.color,
                        currentAppData.seat,
                    );
                }

                // console.log('year make model preset: ', year, make, model);
                setCurrentAppData((prevState) => {
                    let newState = {
                        ...prevState,
                        year: year,
                        make: make,
                        modelTemp: model,
                        model: window.scs_force_custom ? "" : model,
                        //step: newStep,
                        color: "Black",
                        check: check,
                    };
                    if (trim) {
                        newState["trim"] = trim;
                    }
                    if (cab) {
                        newState["cab"] = cab;
                    }
                    return newState;
                });
            }
        }

        runCheck();
    }, []);

    useEffect(() => {
        if (
            slider2 &&
            currentAppData.color &&
            typeof slider2.slickGoTo !== "undefined"
        )
            slider2.slickGoTo(0);
    }, [currentAppData.color]);

    useEffect(() => {
        if (currentAppData.originalProduct) {
            if (window.scs_force_custom === false) {
                setProduct(currentAppData.originalProduct);
            }
        }
    }, [currentAppData.originalProduct]);

    useEffect(() => {
        if (currentAppData.product) {
            if (window.scs_force_custom === true) {
                setProduct(currentAppData.product);
            }
        }
    }, [currentAppData.product]);

    const getCustomProduct = (value: string, trim: string) => {
        if (window.scs_force_normal === true) {
            return {};
        }
        custom_refetch();
        // console.log('getCustomProduct data', custom_data);

        return custom_data;
    };

    //DONE: when selecting color show only the images and thumbs for that color
    //DONE: move arrows for vertical slider top and bottom of slider
    //DONE: move arrows of main slider to be over the image

    //DONE: optimize images

    const options = {
        pinchToClose: true,
        closeOnVerticalDrag: true,
        escKey: true,
        clickToCloseNonZoomable: true,
    };

    const getBonusTitleProps = function () {
        if (window.scs_show_new_year_promo_section) {
            return {
                title: "🎁 2 FREE GIFTS WITH PURCHASE",
                subtitle: "Select Year Make Model To Begin",
            };
        }
        if (window.scs_show_bf_section || window.scs_black_friday_2025) {
            return {
                title: window.scs_intro_text_1,
                subtitle: window.scs_intro_text_2,
            };
        }
        if (window.scs_show_earlybf_section) {
            return {
                title: "🎁 2 FREE GIFTS WITH YOUR ORDER",
                subtitle: "Select Year Make Model To Begin",
            };
        }
        return {
            title: "🎁 FREE GIFTS WITH YOUR ORDER",
            subtitle: "Select Year Make Model To Begin",
        };
    };

    let hideBonusSection =
        window.is_real_truck ||
        window.scs_force_custom ||
        window.scs_show_bonus_section;

    if (window.scs_show_str_section) {
        hideBonusSection = false;
    }

    function getCustomProductTitle(title) {
        if (
            window.scs_use_custom_title &&
            currentAppData?.year &&
            currentAppData?.make &&
            currentAppData?.model
        ) {
            return `${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model} Luxury Seat Covers`;
        }
        return title;
    }

    function handleReviewsClick() {
        console.log('dispatch reviewsClickedEvent');
        const evt = new CustomEvent("reviewsClickedEvent", {
            bubbles: true,
            cancelable: true,
            detail: {message: "reviews"} // optional payload
        });
        document.dispatchEvent(evt);
    }

    function renderElem(el, product) {
        switch (el.type) {
            case "title":
                return <h1>{getCustomProductTitle(product.title)}</h1>;
            case "countdown":
                return window.scs_show_timer ? (
                    <Countdown date={new Date(window.scs_countdown_timer).getTime()}/>
                ) : (
                    ""
                );
            case "bonus_section":
                return hideBonusSection ? "" : <BonusSection/>;
            case "bonus_3_title_section":
                return ((window.scs_hide_timer !== true && window.scs_show_bonus_section && window.scs_force_normal)
                    || (window.scs_title_show_timer)) ? (
                    <Bonus3TitleSection
                        title={getBonusTitleProps().title}
                        subtitle={getBonusTitleProps().subtitle}
                    ></Bonus3TitleSection>
                ) : (
                    ""
                );
            case "status_bar":
                return <StatusBar/>;
            case "step1":
                return <Step1 id="default"/>;
            case "next_steps":
                return (
                    <>
                        <MainStep id="default"/>
                        <div>
                            <StepNoCompatible id="default"/>
                        </div>
                    </>
                );
            case "bonus_3_tier_section":
                return window.scs_hide_bonus_3_section !== true && window.scs_show_bonus_section && window.scs_force_normal ? (
                    <Bonus3Section></Bonus3Section>
                ) : (
                    ""
                );
            case "title_reviews":

                setTimeout(function () {
                    if (!document.querySelector('[itemprop="reviewCount"]')) {
                        return;
                    }
                    var count = document.querySelector('[itemprop="reviewCount"]').getAttribute('content');
                    if (count) {
                        setReviewCount(count);
                    }
                }, 1000)


                return window.is_real_truck ? (
                    ""
                ) : (
                    <div className={`${styles.product_review}`} onClick={handleReviewsClick}>
                        <div className={`${styles.product_stars}`}>
                            <svg
                                width="17"
                                height="15"
                                viewBox="0 0 17 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"
                                />
                            </svg>

                            <svg
                                width="17"
                                height="15"
                                viewBox="0 0 17 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"
                                />
                            </svg>

                            <svg
                                width="17"
                                height="15"
                                viewBox="0 0 17 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"
                                />
                            </svg>

                            <svg
                                width="17"
                                height="15"
                                viewBox="0 0 17 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"
                                />
                            </svg>

                            <svg
                                width="17"
                                height="15"
                                viewBox="0 0 17 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"
                                />
                            </svg>
                        </div>
                        <span className={`${styles.review_text}`}>
              4.9/5 By Thousands of Happy Drivers
            </span>
                    </div>
                );
            default:
                return <RawHtml html={el.content}/>;
        }
    }

    function upsellClose() {

        setCurrentAppData(prevState => {
            return {
                ...prevState,
                show_upsell: false,
                show_offer: false,
                year: '',
                make: '',
                model: '',
                color: 'Black',
                step: 1
            }
        })

        //         show_upsell
        // show_offer
        // hide_upsell

        Shopify.analytics.publish("hide_upsell", {campaign_id: 'double_offer', 'action': 'close'});

    }

    // console.log(
    //     'product?.images?.edges', product?.images?.edges
    // );
    console.log(
        'currentAppData', currentAppData
    );

    return (
        <>
            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span>Error: {error.message}</span>
            ) : product ? (
                <section
                    className={`${styles.section__product} ${window.scs_custom_style ? generalStyles.style01 : ""}`}
                >
                    {window.scs_has_double_offer === true && currentAppData?.show_upsell ?
                        (<section className={`${styles.section__step_upsell}`}>
                            <div className={`${styles.scs_upsell_modal}`}>
                                <div className={`${styles.scs_upsell_modal_content}`}>
                                    <div className={`${styles.scs_upsell_modal_inner}`}>
                                        <div className={`${styles.scs_upsell_close}`} onClick={upsellClose}>
                                            <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.07812 2L16.9996 17" stroke="black" stroke-width="3"/>
                                                <path d="M16.9202 2L1.99879 17" stroke="black" stroke-width="3"/>
                                            </svg>
                                        </div>

                                        <h4>Protect a 2nd Vehicle & <strong>Save <span>$100</span> On Your
                                            Order</strong>
                                        </h4>
                                        <h5>and 2X Your Gifts: <img
                                            src="https://cdn.shopify.com/s/files/1/0732/5909/0212/files/gift-1.png?v=1758698062"
                                            alt="gift 1"/>
                                            <img
                                                src="https://cdn.shopify.com/s/files/1/0732/5909/0212/files/gift-2.png?v=1758698061"
                                                alt="gift 2"/>
                                        </h5>

                                        <div className={`${styles.offer_time}`}>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_5368_2309)">
                                                    <path
                                                        d="M13.7783 11.3859H3.46727L12.3962 5.70878C12.4222 5.69227 12.4446 5.6708 12.4623 5.6456C12.48 5.62039 12.4925 5.59196 12.4992 5.56191C12.5059 5.53186 12.5066 5.50078 12.5013 5.47046C12.496 5.44014 12.4847 5.41116 12.4682 5.38519L11.5836 3.99386C11.3818 3.67731 11.0627 3.45372 10.6963 3.37214C10.3299 3.29056 9.94613 3.35765 9.62914 3.5587L8.3727 4.35757L8.47223 3.88136C8.51146 3.70919 8.51629 3.53096 8.48643 3.35692C8.45657 3.18288 8.39262 3.01645 8.29825 2.8672C8.20387 2.71795 8.08094 2.58882 7.93651 2.48722C7.79208 2.38563 7.62899 2.31357 7.45663 2.2752C7.28427 2.23682 7.10602 2.23288 6.93213 2.26361C6.75824 2.29433 6.59213 2.35911 6.44335 2.45423C6.29457 2.54934 6.16605 2.67292 6.06518 2.81785C5.9643 2.96279 5.89306 3.12623 5.85555 3.29878L5.20281 6.23058L3.01723 5.74409C2.69129 5.67145 2.34997 5.72309 2.06011 5.88889C1.77024 6.05469 1.5527 6.32271 1.45008 6.64048C1.34745 6.95826 1.36714 7.3029 1.50527 7.60692C1.64341 7.91094 1.89006 8.15245 2.19691 8.28417L0.850898 9.14003C0.534361 9.34178 0.310777 9.66085 0.229197 10.0272C0.147618 10.3936 0.214705 10.7774 0.415742 11.0944L1.30039 12.4858C1.3169 12.5118 1.33837 12.5342 1.36356 12.5519C1.38876 12.5696 1.41719 12.5821 1.44724 12.5888C1.47729 12.5955 1.50836 12.5962 1.53867 12.5909C1.56899 12.5856 1.59797 12.5744 1.62395 12.5578L2.44738 12.0344V17.9675C2.44781 18.3429 2.59712 18.7028 2.86255 18.9682C3.12799 19.2336 3.48787 19.3829 3.86324 19.3833H12.597C12.9724 19.3829 13.3322 19.2336 13.5976 18.9682C13.8631 18.7028 14.0123 18.3429 14.0128 17.9675V11.6203C14.0128 11.5895 14.0067 11.559 13.9949 11.5306C13.9831 11.5021 13.9659 11.4763 13.9441 11.4545C13.9223 11.4327 13.8965 11.4155 13.868 11.4037C13.8396 11.3919 13.8091 11.3859 13.7783 11.3859ZM9.88066 3.95433C10.0318 3.85765 10.2075 3.80623 10.387 3.80613C10.4568 3.80616 10.5264 3.81385 10.5946 3.82906C10.7161 3.85578 10.8311 3.90633 10.933 3.9778C11.0348 4.04926 11.1215 4.14021 11.188 4.24538L11.9469 5.43894L8.25547 7.78605L6.98844 5.79331L9.88066 3.95433ZM6.31309 3.4007C6.36372 3.17513 6.50189 2.97892 6.69719 2.85523C6.89249 2.73153 7.12893 2.69049 7.35449 2.74113C7.58006 2.79176 7.77627 2.92993 7.89996 3.12523C8.02365 3.32053 8.0647 3.55697 8.01406 3.78253L7.82164 4.703L5.72527 6.04085L6.31309 3.4007ZM6.59277 6.04484L7.8598 8.03757L5.72074 9.39757L4.45375 7.40484L6.59277 6.04484ZM1.99039 7.52015C1.89788 7.37467 1.8506 7.20503 1.85451 7.03267C1.85842 6.86032 1.91335 6.693 2.01236 6.55186C2.11136 6.41073 2.25 6.30212 2.41073 6.23978C2.57146 6.17744 2.74707 6.16417 2.91535 6.20163L4.8093 6.62327L2.70688 7.9412L2.53648 7.90324C2.42465 7.87866 2.31881 7.83214 2.22507 7.76639C2.13133 7.70063 2.05157 7.61694 1.99039 7.52015ZM1.57027 12.0365L0.811406 10.8429C0.67693 10.6309 0.632047 10.3742 0.686604 10.1291C0.741161 9.88402 0.890702 9.67058 1.10242 9.53562L4.05816 7.65636L5.32516 9.6491L1.57027 12.0365ZM6.11531 18.9146H3.86324C3.61216 18.9143 3.37145 18.8144 3.19391 18.6369C3.01637 18.4593 2.9165 18.2186 2.91621 17.9675V11.8546H6.11543L6.11531 18.9146ZM9.09437 18.9146H6.58406V11.8546H9.09437V18.9146ZM13.5439 17.9675C13.5437 18.2186 13.4438 18.4593 13.2663 18.6368C13.0888 18.8144 12.8481 18.9143 12.597 18.9146H9.56312V11.8546H13.5439V17.9675Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M16.4003 9.25657L16.5124 8.60286C16.5198 8.55977 16.5149 8.51547 16.4985 8.47498C16.482 8.43449 16.4545 8.39941 16.4191 8.37371C16.3838 8.34801 16.3419 8.33271 16.2983 8.32954C16.2547 8.32637 16.2111 8.33546 16.1724 8.35579L15.5854 8.66438L14.9983 8.35579C14.9596 8.33543 14.916 8.32632 14.8723 8.32947C14.8287 8.33262 14.7869 8.34791 14.7515 8.37362C14.7161 8.39932 14.6886 8.43441 14.6721 8.47493C14.6557 8.51544 14.6508 8.55975 14.6582 8.60286L14.7703 9.25657L14.2954 9.71946C14.2641 9.74998 14.2419 9.78866 14.2314 9.83113C14.221 9.87359 14.2226 9.91814 14.2361 9.95974C14.2496 10.0013 14.2745 10.0383 14.3079 10.0665C14.3414 10.0947 14.382 10.113 14.4253 10.1193L15.0816 10.2147L15.3751 10.8094C15.3944 10.8486 15.4244 10.8816 15.4615 10.9047C15.4987 10.9278 15.5415 10.9401 15.5853 10.9401C15.629 10.9401 15.6719 10.9278 15.709 10.9047C15.7462 10.8816 15.7761 10.8486 15.7955 10.8094L16.0889 10.2147L16.7452 10.1193C16.7885 10.113 16.8291 10.0947 16.8626 10.0665C16.896 10.0383 16.9209 10.0013 16.9344 9.95974C16.9479 9.91814 16.9495 9.87359 16.939 9.83113C16.9286 9.78866 16.9064 9.74998 16.8751 9.71946L16.4003 9.25657ZM15.8996 9.76829C15.862 9.77375 15.8263 9.78827 15.7955 9.81061C15.7648 9.83294 15.7399 9.86241 15.7231 9.89649L15.5853 10.1759L15.4474 9.89649C15.4306 9.86242 15.4057 9.83295 15.375 9.81061C15.3442 9.78828 15.3085 9.77375 15.2709 9.76829L14.9626 9.72348L15.1857 9.50602C15.2129 9.4795 15.2333 9.44675 15.245 9.41061C15.2568 9.37447 15.2595 9.33602 15.2531 9.29856L15.2004 8.99145L15.4762 9.13641C15.5098 9.15411 15.5473 9.16336 15.5853 9.16336C15.6233 9.16336 15.6607 9.15411 15.6943 9.13641L15.9701 8.99145L15.9174 9.29856C15.911 9.33601 15.9138 9.37447 15.9255 9.41061C15.9372 9.44675 15.9576 9.47949 15.9848 9.50602L16.2079 9.72348L15.8996 9.76829Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M19.095 6.02729L18.4504 5.87065L18.2141 5.25101C18.1985 5.21013 18.1718 5.17444 18.137 5.14795C18.1022 5.12147 18.0607 5.10525 18.0171 5.10114C17.9736 5.09702 17.9297 5.10518 17.8906 5.12468C17.8514 5.14418 17.8185 5.17424 17.7956 5.21147L17.4475 5.77604L16.7851 5.80936C16.7414 5.81156 16.6992 5.82594 16.6633 5.85086C16.6274 5.87578 16.5991 5.91026 16.5818 5.95039C16.5644 5.99053 16.5586 6.03472 16.5651 6.07797C16.5715 6.12123 16.5899 6.16181 16.6182 6.19515L17.0476 6.70065L16.8746 7.34089C16.8632 7.38311 16.8638 7.42768 16.8764 7.46955C16.889 7.51143 16.9131 7.54895 16.9459 7.57787C16.9787 7.60679 17.019 7.62595 17.0621 7.63318C17.1052 7.64042 17.1495 7.63544 17.19 7.61882L17.8033 7.36671L18.359 7.72909C18.3956 7.75298 18.4382 7.76615 18.4819 7.76711C18.5256 7.76807 18.5688 7.75677 18.6064 7.73451C18.644 7.71224 18.6747 7.67989 18.6949 7.64111C18.7151 7.60233 18.7241 7.55867 18.7208 7.51507L18.6706 6.85374L19.1867 6.43745C19.2207 6.41 19.2464 6.37358 19.2608 6.3323C19.2752 6.29103 19.2778 6.24654 19.2683 6.20387C19.2587 6.16121 19.2374 6.12206 19.2068 6.09085C19.1762 6.05965 19.1375 6.03763 19.095 6.02729ZM18.2803 6.56636C18.2507 6.59021 18.2274 6.6209 18.2123 6.65577C18.1972 6.69065 18.1908 6.72867 18.1937 6.76655L18.2172 7.07722L17.9562 6.90694C17.9244 6.88619 17.888 6.87348 17.8501 6.86991C17.8123 6.86634 17.7742 6.87203 17.739 6.88647L17.4509 7.00491L17.5322 6.70413C17.5421 6.66745 17.5429 6.62891 17.5346 6.59183C17.5263 6.55475 17.5091 6.52024 17.4845 6.49128L17.2829 6.25382L17.594 6.23819C17.632 6.2363 17.6689 6.2252 17.7016 6.20586C17.7343 6.18652 17.7619 6.15952 17.7818 6.12718L17.9453 5.86198L18.0563 6.15308C18.0699 6.18857 18.0918 6.22024 18.1203 6.24536C18.1488 6.27047 18.183 6.28829 18.2199 6.29726L18.5227 6.37085L18.2803 6.56636Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M15.6493 2.21721L15.4763 2.85744C15.4649 2.89966 15.4655 2.94424 15.4781 2.98612C15.4907 3.02801 15.5148 3.06553 15.5476 3.09446C15.5804 3.12338 15.6206 3.14254 15.6638 3.14978C15.7069 3.15702 15.7512 3.15204 15.7917 3.13541L16.4049 2.88326L16.9604 3.24572C16.9971 3.26962 17.0397 3.28279 17.0834 3.28374C17.1271 3.2847 17.1702 3.2734 17.2079 3.25113C17.2455 3.22886 17.2761 3.1965 17.2964 3.15772C17.3166 3.11893 17.3255 3.07527 17.3222 3.03166L17.272 2.37033L17.7883 1.954C17.8223 1.92656 17.848 1.89013 17.8624 1.84886C17.8768 1.80758 17.8794 1.7631 17.8698 1.72043C17.8603 1.67776 17.839 1.63861 17.8084 1.60741C17.7778 1.5762 17.739 1.55419 17.6965 1.54385L17.052 1.38725L16.8157 0.767559C16.8001 0.726692 16.7734 0.691001 16.7386 0.664524C16.7038 0.638047 16.6622 0.621839 16.6187 0.617734C16.5751 0.613629 16.5313 0.621791 16.4922 0.641296C16.453 0.660801 16.4201 0.690871 16.3972 0.728106L16.0491 1.29264L15.3867 1.32592C15.343 1.32811 15.3008 1.34248 15.2649 1.3674C15.2289 1.39232 15.2007 1.42679 15.1833 1.46693C15.166 1.50707 15.1602 1.55126 15.1666 1.59452C15.1731 1.63777 15.1915 1.67836 15.2198 1.7117L15.6493 2.21721ZM16.1958 1.75455C16.2338 1.75264 16.2707 1.74154 16.3034 1.72219C16.3361 1.70285 16.3636 1.67584 16.3836 1.6435L16.5471 1.3783L16.6581 1.66939C16.6716 1.7049 16.6936 1.73658 16.7221 1.7617C16.7506 1.78682 16.7848 1.80464 16.8217 1.81361L17.1245 1.88717L16.882 2.08271C16.8524 2.10656 16.829 2.13725 16.814 2.17212C16.7989 2.207 16.7925 2.24502 16.7954 2.28291L16.8188 2.59361L16.5578 2.42334C16.526 2.40258 16.4896 2.38987 16.4518 2.38631C16.4139 2.38274 16.3758 2.38843 16.3407 2.40287L16.0526 2.52131L16.1338 2.22053C16.1437 2.18384 16.1446 2.14529 16.1363 2.1082C16.128 2.07112 16.1108 2.0366 16.0862 2.00764L15.8845 1.77014L16.1958 1.75455Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M11.3954 9.29042C10.8663 9.62343 10.6077 10.0269 10.597 10.044C10.5637 10.0965 10.5526 10.16 10.5662 10.2207C10.5798 10.2814 10.6169 10.3341 10.6694 10.3674C10.7219 10.4007 10.7855 10.4118 10.8461 10.3982C10.9068 10.3846 10.9596 10.3475 10.9929 10.295C11.028 10.2403 11.876 8.95851 13.7218 9.41507C13.7819 9.42936 13.8452 9.41933 13.8979 9.38718C13.9507 9.35502 13.9886 9.30333 14.0035 9.24336C14.0183 9.18339 14.0089 9.11998 13.9772 9.06693C13.9455 9.01387 13.8942 8.97547 13.8344 8.96007C12.6988 8.6791 11.8812 8.9846 11.3954 9.29042Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M15.8447 6.80837C15.9021 6.8322 15.9666 6.83224 16.0241 6.80849C16.0815 6.78474 16.1272 6.73915 16.151 6.68173C16.1748 6.62432 16.1749 6.55979 16.1511 6.50234C16.1274 6.44489 16.0818 6.39923 16.0244 6.3754C14.3559 5.68294 13.1432 6.2015 12.4197 6.75853C11.9397 7.13179 11.5424 7.60061 11.253 8.13532C11.2393 8.16289 11.2312 8.19289 11.2291 8.22359C11.227 8.2543 11.2309 8.28512 11.2407 8.31429C11.2506 8.34347 11.266 8.37042 11.2863 8.39362C11.3065 8.41681 11.3311 8.4358 11.3587 8.44949C11.3862 8.46317 11.4162 8.4713 11.4469 8.4734C11.4776 8.47549 11.5085 8.47152 11.5376 8.46171C11.5668 8.45189 11.5937 8.43643 11.6169 8.4162C11.6401 8.39597 11.6591 8.37137 11.6728 8.3438C11.9311 7.87325 12.2825 7.46023 12.7056 7.12993C13.6153 6.42974 14.6714 6.32146 15.8447 6.80837Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M13.2106 5.07202C13.1915 5.13116 13.1966 5.19548 13.2249 5.25082C13.2532 5.30617 13.3023 5.34801 13.3615 5.36714C13.6841 5.46221 14.0187 5.51057 14.3551 5.51073C14.7471 5.51073 15.1998 5.43999 15.6057 5.19937C16.137 4.8846 16.4776 4.34831 16.6188 3.60562C16.6246 3.57533 16.6245 3.54418 16.6183 3.51396C16.6121 3.48374 16.6 3.45504 16.5826 3.42951C16.5653 3.40397 16.5432 3.38211 16.5174 3.36517C16.4916 3.34822 16.4627 3.33654 16.4324 3.33078C16.4021 3.32502 16.371 3.3253 16.3408 3.33161C16.3106 3.33791 16.2819 3.35012 16.2564 3.36752C16.231 3.38493 16.2092 3.40719 16.1923 3.43303C16.1755 3.45887 16.1639 3.48779 16.1582 3.51812C16.0435 4.12206 15.7779 4.55171 15.3688 4.79507C14.5906 5.25808 13.5224 4.92659 13.5055 4.9212C13.4464 4.90215 13.3821 4.90733 13.3268 4.9356C13.2715 4.96388 13.2297 5.01295 13.2106 5.07202Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M10.1115 11.1279C10.195 11.1279 10.2766 11.1032 10.346 11.0568C10.4155 11.0104 10.4696 10.9445 10.5015 10.8674C10.5335 10.7902 10.5418 10.7054 10.5256 10.6235C10.5093 10.5416 10.4691 10.4664 10.4101 10.4073C10.351 10.3483 10.2758 10.3081 10.1939 10.2918C10.112 10.2755 10.0272 10.2839 9.95004 10.3158C9.8729 10.3478 9.80698 10.4019 9.76059 10.4713C9.71421 10.5407 9.68945 10.6223 9.68945 10.7058C9.68959 10.8177 9.7341 10.925 9.81322 11.0041C9.89234 11.0832 9.99962 11.1278 10.1115 11.1279ZM10.1115 10.6592C10.1208 10.6592 10.1298 10.6619 10.1375 10.667C10.1452 10.6721 10.1511 10.6794 10.1547 10.688C10.1582 10.6965 10.1591 10.7059 10.1573 10.7149C10.1555 10.724 10.1511 10.7323 10.1446 10.7388C10.138 10.7454 10.1297 10.7498 10.1207 10.7516C10.1116 10.7534 10.1022 10.7525 10.0937 10.749C10.0851 10.7454 10.0779 10.7394 10.0727 10.7317C10.0676 10.7241 10.0649 10.715 10.0649 10.7058C10.0649 10.6934 10.0699 10.6816 10.0786 10.6729C10.0873 10.6642 10.0992 10.6592 10.1115 10.6592Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M13.4338 3.47166C13.5173 3.47166 13.5989 3.4469 13.6683 3.40052C13.7378 3.35414 13.7919 3.28822 13.8238 3.21109C13.8558 3.13395 13.8641 3.04908 13.8478 2.9672C13.8315 2.88532 13.7913 2.81011 13.7323 2.75107C13.6733 2.69204 13.5981 2.65184 13.5162 2.63555C13.4343 2.61927 13.3494 2.62762 13.2723 2.65957C13.1952 2.69152 13.1292 2.74562 13.0829 2.81504C13.0365 2.88445 13.0117 2.96607 13.0117 3.04955C13.0118 3.16146 13.0564 3.26876 13.1355 3.34789C13.2146 3.42702 13.3219 3.47154 13.4338 3.47166ZM13.4338 3.00291C13.4431 3.00291 13.4521 3.00565 13.4598 3.01078C13.4674 3.01591 13.4734 3.0232 13.477 3.03174C13.4805 3.04027 13.4814 3.04965 13.4796 3.05871C13.4778 3.06777 13.4734 3.07608 13.4668 3.08261C13.4603 3.08914 13.452 3.09358 13.4429 3.09538C13.4339 3.09717 13.4245 3.09624 13.4159 3.09271C13.4074 3.08917 13.4001 3.08318 13.395 3.0755C13.3899 3.06781 13.3871 3.05878 13.3871 3.04955C13.3872 3.03719 13.3921 3.02536 13.4009 3.01663C13.4096 3.00789 13.4215 3.00296 13.4338 3.00291Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M19.383 3.14966C19.2996 3.14966 19.2179 3.17442 19.1485 3.2208C19.0791 3.26718 19.025 3.33311 18.9931 3.41024C18.9611 3.48737 18.9528 3.57225 18.9691 3.65413C18.9853 3.73601 19.0255 3.81123 19.0846 3.87026C19.1436 3.92929 19.2188 3.96949 19.3007 3.98577C19.3826 4.00205 19.4675 3.99369 19.5446 3.96173C19.6217 3.92978 19.6877 3.87567 19.734 3.80625C19.7804 3.73683 19.8052 3.65522 19.8052 3.57173C19.805 3.45982 19.7605 3.35253 19.6814 3.2734C19.6022 3.19428 19.495 3.14977 19.383 3.14966ZM19.383 3.61841C19.3738 3.61841 19.3648 3.61567 19.3571 3.61054C19.3494 3.60541 19.3435 3.59812 19.3399 3.58959C19.3364 3.58106 19.3355 3.57168 19.3373 3.56262C19.3391 3.55357 19.3435 3.54525 19.35 3.53872C19.3566 3.53219 19.3649 3.52775 19.3739 3.52595C19.383 3.52414 19.3924 3.52507 19.4009 3.5286C19.4094 3.53213 19.4167 3.53812 19.4219 3.54579C19.427 3.55347 19.4297 3.5625 19.4297 3.57173C19.4297 3.58409 19.4247 3.59594 19.416 3.60468C19.4073 3.61342 19.3954 3.61836 19.383 3.61841Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M9.93992 8.75097C9.93992 8.66747 9.91516 8.58585 9.86877 8.51643C9.82237 8.44701 9.75644 8.39291 9.67929 8.36097C9.60215 8.32902 9.51726 8.32068 9.43538 8.33699C9.35349 8.35329 9.27828 8.39352 9.21925 8.45257C9.16023 8.51163 9.12005 8.58686 9.10379 8.66876C9.08752 8.75066 9.09592 8.83554 9.1279 8.91266C9.15989 8.98979 9.21403 9.0557 9.28347 9.10205C9.35292 9.14841 9.43455 9.17312 9.51805 9.17308C9.62992 9.1729 9.73716 9.12836 9.81625 9.04923C9.89533 8.97011 9.93981 8.86284 9.93992 8.75097ZM9.51805 8.79784C9.50882 8.79785 9.4998 8.79512 9.49212 8.79001C9.48445 8.78489 9.47846 8.77762 9.47491 8.7691C9.47137 8.76058 9.47043 8.7512 9.47221 8.74215C9.47399 8.7331 9.47841 8.72478 9.48492 8.71824C9.49143 8.7117 9.49972 8.70723 9.50877 8.70541C9.51781 8.70358 9.52719 8.70447 9.53573 8.70798C9.54426 8.71148 9.55157 8.71743 9.55672 8.72508C9.56188 8.73273 9.56465 8.74174 9.56469 8.75097C9.56464 8.76336 9.55968 8.77523 9.5509 8.78397C9.54213 8.79272 9.53024 8.79764 9.51785 8.79765L9.51805 8.79784Z"
                                                        fill="black"/>
                                                    <path
                                                        d="M18.6875 9.01611C18.604 9.01611 18.5224 9.04087 18.453 9.08725C18.3836 9.13363 18.3295 9.19956 18.2975 9.27669C18.2656 9.35382 18.2572 9.43869 18.2735 9.52057C18.2898 9.60245 18.33 9.67767 18.389 9.7367C18.4481 9.79573 18.5233 9.83593 18.6051 9.85222C18.687 9.86851 18.7719 9.86015 18.849 9.8282C18.9262 9.79625 18.9921 9.74215 19.0385 9.67273C19.0849 9.60332 19.1096 9.52171 19.1096 9.43822C19.1095 9.32631 19.065 9.21902 18.9858 9.13988C18.9067 9.06075 18.7994 9.01624 18.6875 9.01611ZM18.6875 9.48486C18.6783 9.48486 18.6693 9.48211 18.6616 9.47698C18.6539 9.47185 18.648 9.46457 18.6444 9.45604C18.6409 9.44752 18.64 9.43814 18.6418 9.4291C18.6436 9.42005 18.648 9.41175 18.6546 9.40523C18.6611 9.39871 18.6694 9.39427 18.6785 9.39248C18.6875 9.39068 18.6969 9.3916 18.7054 9.39514C18.7139 9.39867 18.7212 9.40465 18.7263 9.41231C18.7314 9.41998 18.7342 9.429 18.7342 9.43822C18.7341 9.45058 18.7292 9.46241 18.7204 9.47115C18.7117 9.47988 18.6999 9.48481 18.6875 9.48486Z"
                                                        fill="black"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_5368_2309">
                                                        <rect width="20" height="20" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            {(() => {
                                                const tomorrow = new Date();
                                                tomorrow.setDate(tomorrow.getDate() + 1);
                                                const options = {month: "short", day: "numeric"};
                                                const formattedDate = tomorrow.toLocaleDateString("en-US", options);
                                                return `Order by ${formattedDate} for guaranteed FREE Gifts!`;
                                            })()}
                                        </div>

                                        <div className={`${styles.btns}`}>
                                            <button className={`${styles.btn_no}`} onClick={() => {

                                                setCurrentAppData(prevState => {
                                                    return {...prevState, show_upsell: false}
                                                })
                                                Shopify.analytics.publish("hide_upsell", {
                                                    campaign_id: 'double_offer',
                                                    action: 'No Thanks'
                                                });

                                            }}>No Thanks
                                            </button>
                                            <button className={`${styles.btn_yes}`} onClick={() => {
                                                setCurrentAppData((prevState) => {
                                                    return {...prevState, year: '', make: '', model: '', step: 1};
                                                });


                                                setCurrentAppData(prevState => {
                                                    return {...prevState, show_offer: true}
                                                })


                                                Shopify.analytics.publish("show_offer", {campaign_id: 'double_offer'});


                                            }}>Claim This Offer
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {currentAppData?.show_offer ? (
                                    <div className={`${styles.scs_upsell_offer}`}>
                                        <div className={`${styles.scs_upsell_offer_inner}`}>
                                            <div className={`${styles.scs_upsell_close}`} onClick={upsellClose}>
                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.07812 2L16.9996 17" stroke="black" stroke-width="3"/>
                                                    <path d="M16.9202 2L1.99879 17" stroke="black" stroke-width="3"/>
                                                </svg>
                                            </div>
                                            <h4>🔓 Offer Unlocked!</h4>
                                            <h6>You're saving an additional <span><strong>$100</strong> + 2X Your Gifts:</span>
                                            </h6>
                                            <div className={`${styles.steps__offer}`}>
                                                <StatusBar id="offer"/>
                                                <Step1 id="offer"/>
                                                <>
                                                    <MainStep id="offer"/>
                                                    <div>
                                                        <StepNoCompatible id="offer"/>
                                                    </div>
                                                </>
                                            </div>
                                        </div>
                                    </div>) : <></>}

                            </div>
                        </section>) : <>

                            <div className={`${styles.section__product_left}`}>
                                <div className={`${styles.product_images}`}>
                                    <div className={`${styles.product_thumbs}`}>
                                        {product?.images?.edges ? (
                                            <Slider
                                                ref={(slider) => setSlider1(slider)}
                                                {...thumbSettings}
                                            >
                                                {product?.images?.edges
                                                    .filter(
                                                        (image) =>
                                                            image.node &&
                                                            image.node.altText &&
                                                            currentAppData.color &&
                                                            (image.node.altText
                                                                    .toLowerCase()
                                                                    .endsWith(
                                                                        " - " + currentAppData.color.toLowerCase(),
                                                                    ) ||
                                                                image.node.altText
                                                                    .toLowerCase()
                                                                    .endsWith(" - all")),
                                                    )
                                                    .map((image) => {
                                                        return (
                                                            <div key={`thumb-${image.node.id}`}>
                                                                <img
                                                                    src={getImageUrl(image.node.url, 100, 100)}
                                                                    alt={image.node.altText}
                                                                    className={`${styles.thumb_image}`}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                            </Slider>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <div className={`${styles.product_main_image}`}>
                                        {product?.images?.edges ? (
                                            <Gallery id="my-gallery">
                                                <Slider
                                                    ref={(slider) => setSlider2(slider)}
                                                    {...sliderSettings}
                                                >
                                                    {product?.images?.edges
                                                        .filter(
                                                            (image) =>
                                                                image.node &&
                                                                image.node.altText &&
                                                                currentAppData.color &&
                                                                (image.node.altText
                                                                        .toLowerCase()
                                                                        .endsWith(
                                                                            " - " + currentAppData.color.toLowerCase(),
                                                                        ) ||
                                                                    image.node.altText
                                                                        .toLowerCase()
                                                                        .endsWith(" - all")),
                                                        )
                                                        .map((image) => {

                                                            const img_id = image.node.id
                                                                .replace('gid://shopify/ProductImage/', '')
                                                                .replace('gid://shopify/ImageSource/', '');

                                                            const meta_key = 'image_' + img_id;

                                                            //console.log('currentAppData?.captions', currentAppData?.captions);
                                                            const filtered = currentAppData?.captions?.metafields.edges
                                                                .filter((v) => v.node.key === meta_key);

                                                            let filtered_obj = {};
                                                            let caption_style = {};
                                                            if (filtered && filtered.length > 0) {
                                                                filtered_obj = JSON.parse(filtered[0].node.value);
                                                                //console.log('filtered_obj', filtered_obj);
                                                                caption_style = {
                                                                    "--bg-color": filtered_obj.bg_color,
                                                                    "--text-color": filtered_obj.text_color,
                                                                };
                                                            }

                                                            return (
                                                                <Item
                                                                    original={getImageUrl(
                                                                        image.node.url,
                                                                        2000,
                                                                        undefined,
                                                                    )}
                                                                    thumbnail={getImageUrl(
                                                                        image.node.url,
                                                                        600,
                                                                        undefined,
                                                                    )}
                                                                    width="2000"
                                                                    height="2000"
                                                                >
                                                                    {({ref, open}) => (
                                                                        <div
                                                                            key={`image-${image.node.id}`}
                                                                            data-id={image.node.id}
                                                                            className={`${styles.slide_item} ${image.node.video_url ? styles.slide_video : ""}`}
                                                                        >
                                                                            {image.node.video_url ? (
                                                                                <video
                                                                                    width="100%"
                                                                                    loop={true}
                                                                                    preload="auto"
                                                                                    autoPlay
                                                                                    playsInline
                                                                                    muted={true}
                                                                                    webkit-playsinline={true}
                                                                                    controls={false}
                                                                                    webkit-playsinline
                                                                                >
                                                                                    <source
                                                                                        src={image.node.video_url}
                                                                                        type={image.node.video_type}
                                                                                    />
                                                                                    Your browser does not support the
                                                                                    video
                                                                                    tag.
                                                                                </video>
                                                                            ) : (
                                                                                <img
                                                                                    ref={ref}
                                                                                    onClick={open}
                                                                                    src={getImageUrl(
                                                                                        image.node.url,
                                                                                        600,
                                                                                        undefined,
                                                                                    )}
                                                                                    alt={image.node.altText}
                                                                                    className={`${styles.main_image}`}
                                                                                />
                                                                            )}

                                                                            {filtered && filtered.length > 0 ?
                                                                                (<div
                                                                                    className={`${styles.image_caption} ${styles[filtered_obj.caption_position]}`}
                                                                                    style={caption_style}>
                                                                                    {filtered_obj.line1 && filtered_obj.line1 != '' ? (
                                                                                        <div
                                                                                            className={`${styles.caption_line}`}>{filtered_obj.line1}</div>) : ''}
                                                                                    {filtered_obj.line2 && filtered_obj.line2 != '' ? (
                                                                                        <div
                                                                                            className={`${styles.caption_line}`}>{filtered_obj.line2}</div>) : ''}
                                                                                </div>) : ''}

                                                                        </div>
                                                                    )}
                                                                </Item>
                                                            );
                                                        })}
                                                </Slider>
                                            </Gallery>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={`${styles.section__product_right}`}>
                                {window.scs_blocks &&
                                    window.scs_blocks.length > 0 &&
                                    window.scs_blocks.map((el) => {
                                        return renderElem(el, product);
                                    })}
                            </div>

                        </>}


                </section>
            ) : (
                <></>
            )}
            <div>{isFetching ? "Background Updating..." : null}</div>
        </>
    );
};

export default Product;
